export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ06B.55138a3a.mp3";